import { useMemo } from 'react';
import { v4 as uuid } from 'uuid';

import { useTypedSelector } from 'store';
import { TableAddressChip } from 'ui/Table/TableAddressChip/TableAddressChip';
import { TableCheckbox } from 'ui/Table/TableCheckbox/TableCheckbox';
import { ENetwork } from 'web3';

interface IWalletAddress {
  getIsSelected: () => boolean;
  getIsSomeSelected: () => boolean;
  getToggleSelectedHandler: () => (e: unknown) => void;
  address: string;
  network: ENetwork;
  isImported: boolean;
}

export function WalletAddressTableRow({
  address,
  getIsSelected,
  getIsSomeSelected,
  getToggleSelectedHandler,
  network,
  isImported,
}: IWalletAddress) {
  const isAdmin = useTypedSelector(store => store.auth.isAdmin);

  const checkboxId = useMemo(() => uuid(), []);

  return (
    <div className="checkbox-area">
      {isAdmin && (
        <TableCheckbox
          id={checkboxId}
          checked={getIsSelected()}
          indeterminate={getIsSomeSelected()}
          onChange={getToggleSelectedHandler()}
        />
      )}
      <TableAddressChip
        address={address}
        network={network}
        addressType="address"
        isImported={isImported}
      />
    </div>
  );
}
